import { render, staticRenderFns } from "./_evoplay.vue?vue&type=template&id=066c1a5b&lang=pug&"
import script from "./_evoplay.vue?vue&type=script&lang=js&"
export * from "./_evoplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports